import BaseModelAPI from '../BaseModelAPI';

export default class ControlCardStatusList extends BaseModelAPI {

	static entity = 'controlcardstatuslist'
	static entityName = 'controlcardstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
